export default __webpack_public_path__ + "static/media/FS-TUTORIALES-ICONO-AZUL.375fb2cf.svg";